import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { navy, muted, primary } from '../Layout/Resources/Theme'

const Wrap = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`

const Left = styled.div`
  min-width: 0;
`

const Eyebrow = styled.div`
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${primary};
  margin-bottom: 4px;
`

const Title = styled.h2`
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: ${navy};
  line-height: 1.3;
`

const Subtitle = styled.p`
  margin: 4px 0 0;
  font-size: 0.85rem;
  color: ${muted};
`

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`

const PageHeader = ({ eyebrow, title, subtitle, actions }) => {
  return (
    <Wrap>
      <Left>
        {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
        {title ? <Title>{title}</Title> : null}
        {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
      </Left>
      {actions ? <Actions>{actions}</Actions> : null}
    </Wrap>
  )
}

PageHeader.propTypes = {
  eyebrow: PropTypes.node,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  actions: PropTypes.node
}

PageHeader.defaultProps = {
  eyebrow: null,
  title: null,
  subtitle: null,
  actions: null
}

export default PageHeader
